import React, { useMemo, useState, useEffect } from 'react';
import { useSortBy, useTable, usePagination, useFilters } from 'react-table';
import t from '../../Utils/Translation';
import LykioButton from "../common/LykioButton";
import friendlyDate from '../../Utils/FriendlyDate';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import UserEditionCodesModal from './UserEditionCodesModal';

const UsersEditionCodes = (props) => {
	const assignAdminRole = localStorage.getItem('localca')==='true' ? true : false;
	//const assignAdminRole = props.assignAdminRole;
	const users = assignAdminRole ? props.users.filter(user=> user.role.name!=='uber') : props.users.filter(user=> user.role.name!=='admin');
	const [ myTableData, setmyTableData ] = useState(useMemo(() => [ ...users ], []));

	// Define defaultColumn and filterTypes
	const defaultColumn = React.useMemo(
		() => ({
		Filter: () => null, 
		}),
		[]
	);
  
	const filterTypes = React.useMemo(
		() => ({
		rankedMatchSorter: (rows, id, filterValue) => {
			return rows.filter((row) => {
			const rowValue = row.values[id];
			return rowValue === filterValue;
			});
		},
		}),
		[]
	);
  
	
	//Table Design Headers/Columns
	const myTableColumns = useMemo(
		() => [
		  {
			Header: t('Full Name'),
			accessor: 'fullName',
			Filter: ({ column }) => {
			  return (
				<input
				  style={{width:'200px', marginRight:'5px'}}
				  type="text"
				  value={column.filterValue || ''}
				  onChange={(e) => {
					column.setFilter(e.target.value || undefined);
				  }}
				  placeholder={t('Search by Name')}
				/>
			  );
			},
		  },
		  {
			Header: t('Email'),
			accessor: 'email',
			Filter: ({ column }) => {
			  return (
				<input
				  style={{width:'200px', marginRight:'5px'}}
				  type="text"
				  value={column.filterValue || ''}
				  onChange={(e) => {
					column.setFilter(e.target.value || undefined);
				  }}
				  placeholder={t('Search by Email')}
				/>
			  );
			},
		  },
		  {
			Header: (
				<div style={{ paddingRight: '10px' }}>{t('Creation Date')}</div>
			),
			accessor: 'creationDate',
			Cell: ({ value }) => {
			  // Use the friendlyDate function to format the date
			  const formattedDate = friendlyDate(value);
			  return <div style={{ paddingRight: '10px' }}>{formattedDate}</div>;
			},
		  },
		],
		[]
	  );
	  

	//Insert column with Actions buttons
	const tableHooks = (hooks) => {
		hooks.visibleColumns.push((columns) => [
			...columns,
			{
				id: 'Actions',
				Header: t('Actions'),
				Cell: ({ row }) => {
					const [show, setShow] = useState(false);
					const handleClose = () => setShow(false);
					const handleShow = () => setShow(true);
					return <React.Fragment>
						<React.Fragment>
							{userTableButtonComponent('View Edition Codes', () => {handleShow()})}
							{/*console.log("*** users[row.id]___________________:",users[row.id].editionCodes)*/}
							<UserEditionCodesModal key={row.id} userId={users[row.id]._id} 
							userEditionCodes={users[row.id].editionCodes} 
							editionCodesList={props.editionCodesList}
							show={show} handleClose={handleClose} />
						</React.Fragment>
					</React.Fragment>
				}
			}
		]);
	};

	//React Table Setup
	const tableInstance = useTable(
		{ columns: myTableColumns, data: myTableData, defaultColumn, filterTypes, },
		tableHooks,
		useFilters,
		useSortBy,
		usePagination
	);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		pageOptions,
		gotoPage,
		pageCount,
		setPageSize,
		state,
		prepareRow
	} = tableInstance;

	const { pageIndex, pageSize } = state;

	//LykioButton Component
	const userTableButtonComponent = (label, buttonHandler) => {
		return (<React.Fragment>
			<LykioButton variant="text" onClick={() => {
				buttonHandler();
			}}>
				{t(`${label}`)}
			</LykioButton>&nbsp;
			</React.Fragment>
		);
	};

	return (
		<React.Fragment>
			<Table striped bordered hover size="sm" {...getTableProps()}>
				<TableHead>
					{headerGroups.map((headerGroup) => (
						<TableRow {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => {
								const cellStyle = {
									verticalAlign: "top", 
								  };
								  return (
									<th {...column.getHeaderProps(column.getSortByToggleProps())} style={cellStyle}>
										{column.render('Header')}
										{column.isSorted ? column.isSortedDesc ? ' ↓' : ' ↑' : ''}
										<div>{column.canFilter ? column.render("Filter") : null}</div>
									</th>
								);
							})}
						</TableRow>
					))}
				</TableHead>
				<TableBody {...getTableBodyProps()}>
					{page.map((row) => {
						prepareRow(row);
						return (
							<TableRow {...row.getRowProps()}>
								{row.cells.map((cell) => {
									return (
									<TableCell {...cell.getCellProps()}>
										{cell.column.id === 'creationDate' ? (
										cell.render('Cell')
										) : (
										cell.render('Cell')
										)}
									</TableCell>
									)
									})
								}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>

			{/*Pagination*/}
			<div className="lykiocss-pagination" style={{marginTop:'1rem'}}>
				<LykioButton variant="contained" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
					{t('First')}
				</LykioButton>&nbsp;
				<LykioButton variant="contained" onClick={() => previousPage()} disabled={!canPreviousPage}>
					{t('Previous')}
				</LykioButton>&nbsp;
				<span className="lykiocss-pageNum">
					{' '}
					{t('Page')} {pageIndex + 1} / {pageOptions.length}{' '}
				</span>&nbsp;
				<span>
					{' '}
					| {t('Page')}{' '}
					<input
						className="lykiocss-pageSelector"
						type="number"
						value={pageIndex + 1}
						onChange={(e) => gotoPage(e.target.value ? Number(e.target.value) - 1 : 0)}
					/>{' '}
				</span>&nbsp;
				<LykioButton variant="contained" onClick={() => nextPage()} disabled={!canNextPage}>
					{t('Next')}
				</LykioButton>&nbsp;
				<LykioButton
					variant="contained"
					onClick={() => gotoPage(pageCount - 1)}
					disabled={!canNextPage}
				>
					{t('Last')}
				</LykioButton>&nbsp;
				<select
					className="lykiocss-items-count-selector"
					value={pageSize}
					onChange={(e) => setPageSize(Number(e.target.value))}
				>
					{[ 5, 10, 25, 50, 100 ].map((pageSize) => (
						<option key={pageSize} value={pageSize}>
							{' '}
							{pageSize}
						</option>
					))}
				</select>
			</div>
		</React.Fragment>
	);
};

export default UsersEditionCodes;
